import { Col, Form, Row } from "antd"

import Flex from "#blocks/Flex"
import { AddStudentFormValues } from "#customTypes/composedTypes/studentTypes"

import StudentAttendanceList from "./StudentAttendanceList"
import StudentMakeupsList from "./StudentMakeupsList"
import StudentTasksList from "./StudentTasksList"

const AddStudentDetails = () => {
  const form = Form.useFormInstance<AddStudentFormValues>()
  const studentId = form.getFieldValue("id")

  return (
    <Flex col gap={40}>
      <Row gutter={16}>
        <Col span={12}>
          <StudentTasksList />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <StudentAttendanceList studentId={studentId} />
        </Col>

        <Col span={12}>
          <StudentMakeupsList />
        </Col>
      </Row>
    </Flex>
  )
}

export default AddStudentDetails
